import styles from './AchievedCorrection.module.css';

import { Fragment } from 'react';

import { MetricComparison, MetricSession } from '../../models/CaseTypes';

const renderVertebraRange = (vertebra: string): React.JSX.Element => {
  if (vertebra.includes('-')) {
    const [start, end] = vertebra.split('-');
    return (
      <span>
        <span className={styles[`vertebra-${start}`]}>{start}</span>
        <span className="vertebra-separator">-</span>
        <span className={styles[`vertebra-${end}`]}>{end}</span>
      </span>
    );
  }
  return <span className="vertebra-single">{vertebra}</span>;
};

interface AchievedCorrectionMetricsProps {
  comparisonData: MetricComparison[];
  comparisonSession: MetricSession|null;
  primarySession: MetricSession|null;
  selectedVertebrae: Record<string, boolean>;
  onVertebraeCheckboxChange: (metric: MetricComparison, isChecked: boolean) => void;
}

const AchievedCorrectionMetrics = (
  {
    comparisonData,
    comparisonSession,
    primarySession,
    selectedVertebrae,
    onVertebraeCheckboxChange
  } : AchievedCorrectionMetricsProps): React.JSX.Element => {
  return (
    <div className={`${styles['metrics-table-container']}`}>
      {
        comparisonData.length > 0 &&
        (
          <table className={styles['metrics-data-table']}>
            <thead>
              <tr>
                <th data-testid="select-vertebrae" className="text-center" style={{ width: '45px' }}></th>
                <th data-testid="vertebrae">Vertebrae</th>
                <th>Measurement</th>
                <th>
                  {primarySession?.sessionNameShorthand || ''}
                </th>
                <th>
                  {comparisonSession?.sessionNameShorthand || ''}
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((metric, index) => (
                <Fragment key={`metric_row_${metric.id}`}>
                  {
                    (
                      <tr
                        className={selectedVertebrae[metric.vertebra] ? styles['metric-selected'] : ''}
                        data-testid={
                          `metric-row-${metric.vertebra.trim()}-${metric.label
                            .replace(' ', '')
                            .replace('.', '')}`
                        }
                        onClick={() => {
                          const isChecked = !!selectedVertebrae[metric.vertebra];
                          onVertebraeCheckboxChange(metric, !isChecked);
                        }}
                      >
                        <td className={`text-center 
                          ${

                      (index > 0 && comparisonData[index - 1].vertebra !== metric.vertebra) &&
                            styles['metric-no-top-border']
                      }
                          
                    ${
                      (
                        index < comparisonData.length - 1 &&
                        comparisonData[index + 1].vertebra === metric.vertebra) &&
                            styles['metric-no-bottom-border']
                      }
                          `}>
                          {(index === 0 || comparisonData[index - 1].vertebra !== metric.vertebra) ? (
                            <input
                              type="checkbox"
                              aria-label={`Select ${metric.vertebra}`}
                              data-testid={
                                `checkbox-${metric.vertebra.trim()}-${metric.label
                                  .replace(' ', '')
                                  .replace('.', '')}`
                              }
                              className={styles['vertebra-checkbox']}
                              checked={!!selectedVertebrae[metric.vertebra]}
                              onChange={e =>
                                onVertebraeCheckboxChange(metric, e.target.checked)
                              }
                            />
                          ) : null}
                        </td>
                        <td>{renderVertebraRange(metric.vertebra)}</td>
                        <td>{metric.label}</td>
                        <td>{metric.preValueDesc}</td>
                        <td>{metric.postValueDesc} <span>{metric.valueDiffDesc}</span></td>
                      </tr>
                    )}
                </Fragment>
              ))}
            </tbody>
          </table>
        )}
    </div>
  );
};
export default AchievedCorrectionMetrics;
